import { combineReducers } from "redux";
import authReducer from "./authReducer";
import commonReducer from "./commonReducer";
import crmReducer from "./crmReducer";
import profileTableReducer from "./profileTableReducer";
import projectDetailsReducer from "./projectDetailsReducer";
import tabReducer from "./tabReducer";
import recruitmentReducer from "./recruitmentReducer";
import requiredReducer from "./requiredReducer";
import finalSelectionReducer from "./finalSelectionReducer";
import suspendedReducer from "./suspendedReducer";
import closedReducer from "./closedReducer";
import viewProjectReducer from "./viewProjectReducer";
import notificationReducer from "./notificationReducer";
import finalSelectionCandidatesReducer from "./finalCandidateReducer";
import candidateListReducer from "./candidateReducer";

const rootReducers = combineReducers({
  auth: authReducer,
  common: commonReducer,
  crm: crmReducer,
  profileTable: profileTableReducer,
  tab: tabReducer,
  projectDetails: projectDetailsReducer,
  recruit: recruitmentReducer,
  required: requiredReducer,
  final: finalSelectionReducer,
  suspend: suspendedReducer,
  closed: closedReducer,
  viewProject: viewProjectReducer,
  notification: notificationReducer,
  finalSelectionCandidates: finalSelectionCandidatesReducer,
  candidates: candidateListReducer,
});

export default rootReducers;
